
import ApiService from './ApiService'
import LocalStorageService from './LocalStorageService'

class OrganisationTagService {
  set = async (apiToken, params, data) => {
    var url = '/api/organisationtag'

    var options = {
      data: data
    }

    try {
      var result = await ApiService.put(apiToken, url, params, options)
    } catch (err) {
      console.error(err)
    }
    return result
  }

  get = async (apiToken, params, where) => {
    var url = '/api/organisationtag'

    if (where) {
      params.where = where
    }

    params.limit = 1000

    try {
      var organisationTags = await ApiService.get(apiToken, url, params)
    } catch (err) {
      console.error(err)
    }
    return organisationTags?.data
  }

  getAcademicYears = async (apiToken, activeOrg) => {
    const params = {
      fields: 'key,value',
      limit: 1000
    }

    if (!activeOrg) return []

    const where = {
      organisation: activeOrg.id,
      type: 'besmart'
    }

    const terms = LocalStorageService.get('terms')

    const organisationTags = await this.get(apiToken, params, where)
    if (organisationTags?.error) {
      // return {error: organisationTags}
    } else if (organisationTags?.length) {
      const academicYears = organisationTags.find(tag => tag.key === 'enabledAcademicYears')
      try {
        const parsedAcademicYears = JSON.parse(academicYears.value)
        parsedAcademicYears.push('Former')
        parsedAcademicYears.push('Not Specified')

        return parsedAcademicYears
      } catch (err) {
        console.error(err)
      }
    }
  }

  getActiveQuickBehaviourItems = async (apiToken, activeOrg) => {

    const params = {
      fields: 'value',
      limit: 1,
      orgId: activeOrg.id,
    };

    const where = {
      organisation: activeOrg.id,
      type: 'besmart',
      key: 'quickBehaviours',
    };

    const behaviours = await this.get(
      apiToken,
      params,
      where,
    );

    let activeBehaviours = []
    try {
      const parsedBehaviours = JSON.parse(behaviours[0].value);
      for (const thisBehaviour of parsedBehaviours) {
        if (thisBehaviour.selected) {
          activeBehaviours.push({ quickBehaviour: thisBehaviour.quickBehaviour, group: thisBehaviour.group || null, colour: thisBehaviour.colour || null });
        }
      }
    } catch (err) {
      console.error(err);
    }

    return activeBehaviours
  }

  getActiveQuickBehaviours = async (apiToken, activeOrg) => {
    const activeBehaviours = (await this.getActiveQuickBehaviourItems(apiToken, activeOrg)).map(item => item.quickBehaviour)

    // sort by name
    activeBehaviours.sort((a, b) => {
      const nameA = a.replace(/([A-Z])/g, ' $1').toLowerCase();
      const nameB = b.replace(/([A-Z])/g, ' $1').toLowerCase();
      return nameA.localeCompare(nameB);
    });

    return activeBehaviours
  }

  // Returns [{ group, colour, behaviours }] sorted by group (ungrouped last), then by clicker name
  getActiveQuickBehaviourGroups = async (apiToken, activeOrg) => {
    const compare = (a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })
    const items = await this.getActiveQuickBehaviourItems(apiToken, activeOrg)
    const groups = new Map()
    for (const item of items) {
      if (!groups.has(item.group)) groups.set(item.group, { group: item.group, colour: null, behaviours: [] })
      const entry = groups.get(item.group)
      entry.behaviours.push(item.quickBehaviour)
      if (item.group && !entry.colour) entry.colour = item.colour
    }

    return [...groups.values()]
      .map(entry => ({ ...entry, behaviours: entry.behaviours.sort(compare) }))
      .sort((a, b) => {
        if (Boolean(a.group) !== Boolean(b.group)) return a.group ? -1 : 1
        return compare(a.group || '', b.group || '')
      })
  }
}
export default new OrganisationTagService()
